const handleClick = (e) => {
    const button = e.currentTarget;
    const form = button.closest('.form');
    const embeds = form.querySelectorAll('.form__item');

    if (button.classList.contains('is-active')) {
        return;
    }

    button.classList.add('is-active');
    const siblings = Array.from(button.parentNode.children).filter((sibling) => sibling !== button);
    siblings.forEach((sibling) => sibling.classList.remove('is-active'));

    let index = 1;
    embeds.forEach((embed) => {
        embed.classList.remove('is-active');

        if (index == button.dataset.target) {
            embed.classList.add('is-active');
        }
        index++;
    });
};

export default () => {
    const forms = document.querySelectorAll('.form--multi');

    if (!forms) {
        return;
    }

    forms.forEach((el) => {
        const buttons = el.querySelectorAll('.form__button');

        buttons.forEach((button) => {
            button.addEventListener('click', handleClick);
        });
    });
};
